import React from 'react'
import { BlogsList } from './BlogList'

export const LocalSocial = (props) => {
    const latestBlogs = props.latestBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts
    
  return (
    <div className='space-y-8 px-2'>        
        
        <div className='space-y-5 pt-5'>
            <h1 className='font-bold text-2xl md:text-3xl text-center'>
                Local and Social
            </h1>
            <BlogsList blogs={latestBlogs} listAll={true} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
        </div>
    </div>
  )
}
